var React = require('react');

function Sleep (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#a)","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M4 12h6l-6 8h6M14 4h6l-6 8h6"})));
}

Sleep.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Sleep;

Sleep.default = Sleep;
